export const SALES_ANALYTICS_PENDING_STATE = 'SALES_ANALYTICS_PENDING_STATE'
export const SALES_ANALYTICS_COMPLETED_STATE = 'SALES_ANALYTICS_COMPLETED_STATE'

export const SALES_ANALYTICS_LOAD_DATA = 'SALES_ANALYTICS_LOAD_DATA'
export const SALES_ANALYTICS_RESET_DATA = 'SALES_ANALYTICS_RESET_DATA'
